// extracted by extract-css-chunks-webpack-plugin
module.exports = {"review":"Review_review-yQo3P","contacts":"Review_contacts-2qDFt","contactItem":"Review_contactItem-1Agws","rating":"Review_rating-1TFmt"};